<div bsModal style="overflow: auto;" #ratersModal="bs-modal" id="ratersModal" class="modal fade ratersModal" (onShown)="onShown()" role="dialog" aria-labelledby="ratersModal" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="showConfirmCloseRatersModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Raters</h2>
            </div>

            <div class="modal-body">
                <div class="modal-body" style="padding-top: 5px; overflow: auto;">
                    <div class="row">
                        <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                            <h1 class="h3 mb-0 text-gray-800"></h1>
                            <div class="btns-container">
                                <a (click)="openAddRelationshipsModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary margin-right-5">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add Relationship</span></i>
                                </a>
                                <!--<a (click)="openRaterTypesForModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary margin-right-5">
                                    <i class="fas fa-edit text-white-50"> <span class="button-text"> Manage Relationships</span></i>
                                </a>-->
                            </div>
                        </div>
                    </div>

                    <br />

                    <div class="ratersModalAcc">
                        <br />
                        <div *ngIf="noRaters" class="text-center" style="color:red;"><p>Please click the + Add Relationship button to add a Relationship Category</p></div>
                        <div class="categories"></div>
                        <div class="panel-group" id="rtmainAccordion" style="max-height:350px;min-height:350px;overflow-y: scroll; overflow-x:hidden;margin-bottom: -10px;margin-top:-10px;padding-bottom: 5px;">
                            <div id="forFirstelement"></div>
                            <div class="panel panel-default accHide" style="display:none;" id="acc{{rt.Id}}" *ngFor="let rt of raterTypes; let i = index;">
                                <div style="height:35px;" class="accDiv">
                                    <a (click)="drawData(rt.Id, rt.Min, $event)"
                                       [href]="'#rtaccordion'+i"
                                       aria-expanded="false"
                                       data-toggle="collapse"
                                       data-parent="#rtmainAccordion"
                                       [id]="rt.Id" class="panel-heading fieldsTitle collapsed">
                                        <div style="position: relative;top: -20px;" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                                            <h4 class="panel-title">
                                                {{rt.Name}}
                                            </h4>
                                            <i class="fas fa-angle-down"></i>
                                        </div>
                                    </a>
                                </div>
                                <div [id]="'rtaccordion'+i" class="panel-collapse collapse" style="margin-left: -15px;">
                                    <div class="panel-body">
                                        <div class="categoryMinMessage"><span style="position:relative; top:3px; color:red;"></span></div>
                                        <div class="scrollTo" style="overflow:auto;line-height: 0;padding-top: 25px;min-height: 150px;max-height: 200px;">
                                            <div class="row text-left" style="top:-12px;position:relative;display:inline-flex; width:100%;">
                                                <div class="" style="padding: 0 0 5px 3px;min-width:192px;"><label>First Name</label></div>
                                                <div class="" style="padding: 0 0 5px 10px;min-width:192px;"><label>Last Name</label></div>
                                                <div class="" style="padding: 0 10px 5px 10px;min-width:180px;"><label>Email</label></div>
                                                <div class="row dinamicResponsive" style="width:45%;"></div>
                                            </div>
                                            <div class="ratersModalCategoryEntries"></div>
                                        </div>
                                        <div>
                                            <div>
                                                <a style="margin: 10px 0px;" (click)="addNewRaterEntry(rt.Id)" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add</span></i>
                                                </a>
                                                <a style="margin: 10px 0px;" (click)="showRemoveCategoryInitialModal(rt.Id)" class="d-none d-sm-inline-block btn btn-sm btn-red shadow-sm">
                                                    <i class="fas fa-trash text-white-50"> <span class="button-text">Remove Category</span></i>
                                                </a>
                                            </div>
                                            <a class="removeCategory" style="padding-left: 2px;text-decoration: underline;cursor: pointer;" (click)="showBulkDeleteRatersConfirmationModal(rt.Id)"><span class="removeButtonText">Remove Relationship</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />

                </div>
            </div>

            <div class="modal-footer text-right">
                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <a style="text-decoration: underline;cursor: pointer;" (click)="showImportModal()" class="d-none d-sm-inline-block"> Import raters</a>
                    <div class="btns-container">
                        <div *ngIf="!addingNewRater">
                            <!--close()-->
                            <button type="button" (click)="showConfirmCloseRatersModal()" class="btn btn-secondary">Cancel</button>
                            <button type="button" (click)="saveRaters()" class="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*import modal*/-->
<div id="ratersModalImportRaterModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Import Raters</h2>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div *ngIf="importRaterPageIdx == 0" class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="iFile" />
                        </div>
                    </div>
                </div>

                <div *ngIf="importRaterPageIdx == 1" class="row">
                    <div class="page2">
                        <h5>Language and Dates</h5>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Language: </label>
                            </div>
                            <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                                <select #importLanguage id="importLanguages">
                                    <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row radios importRadios">
                            <div class="col-sm-12 col-md-3 datepicker">
                                <label style="text-align: right;">Schedule for:</label>
                            </div>
                            <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="importDatapiker">

                                <label class="container">
                                    Now
                                    <input type="radio" checked="checked" name="schedule" value="0">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <label class="container responsiveRadioLabel">
                                    <span style="margin-left:5px;"></span>
                                    <input type="radio" name="schedule" value="1">
                                    <span style="left: 18px;" class="checkmark"></span>
                                </label>
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event, 'importRadios')" [(ngModel)]="date1" [settings]="settings"></angular2-date-picker> -->
                                <input type="date" [(ngModel)]="date1" (change)="onDateSelect($event, 'importRadios')">
                            </div>
                            <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <select (change)="hourChanged('importRadios')" class="blueSelect" id="importHour">
                                    <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Expires in:</label>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <input id="importExpiresIn" type="number" name="text" value="30" max="30" min="0" />
                                <span>day(s)</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="row">
                        <div class="col-md-12">
                            <button *ngIf="importRaterPageIdx == 0" (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                            <button *ngIf="importRaterPageIdx > 0" (click)="importRaterPrev()" type="button" class="btn btn-primary">Previous</button>
                            <button *ngIf="importRaterPageIdx < 1" style="margin-right: 25px;" (click)="importRaterNext()" type="button" class="btn btn-primary">Next</button>
                            <button *ngIf="importRaterPageIdx == 1" style="margin-right: 25px;" (click)="okImportRaters()" type="button" class="btn btn-primary">Finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--saveRater MODAL-->
<div id="ratersModalSaveRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Raters</h2>
                <button (click)="closeNewRaterModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="page2">
                        <h5>Language and Dates</h5>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Language: </label>
                            </div>
                            <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                                <select #language id="languages">
                                    <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row radios assignedRadios">
                            <div class="col-sm-12 col-md-3 datepicker">
                                <label style="text-align: right;">Schedule for:</label>
                            </div>
                            <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="datapiker">

                                <label class="container">
                                    Now
                                    <input type="radio" checked="checked" name="schedule" value="0">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="divHour">
                                <label class="container responsiveRadioLabel">
                                    <span style="margin-left:5px;"></span>
                                    <input type="radio" name="schedule" value="1">
                                    <span style="left: 18px;" class="checkmark"></span>
                                </label>
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event, 'assignedRadios')" [(ngModel)]="date1" [settings]="settings">
                                </angular2-date-picker> -->
                            </div>
                            <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="divHour">
                                <select (change)="hourChanged('assignedRadios')" class="blueSelect" id="hour">
                                    <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                </select>

                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Expires in:</label>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <input id="expiresIn" type="number" name="text" value="30" max="30" min="0" />
                                <span>day(s)</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="modal-footer">
                <div class="container-fluid row">
                    <div class="col-md-12">
                        <button (click)="closeNewRaterModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="finishSaveRaters()" type="button" class="btn btn-primary">Finish</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!--/*BULK CONFIRMATION DELETE RATERS MODAL*/-->
<div id="ratersModalBulkConfirmDeleteRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Raters</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span class="BDMessage" *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to delete these raters and this category?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Deleting...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirmBulkDeleteRaters()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE RATERS MODAL*/-->
<div id="ratersModalConfirmDeleteRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Rater</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to delete this rater?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Deleting...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirmDeleteRaters()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE RATERS MODAL*/-->
<div id="ratersModalConfirmCloseRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Raters</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">You have unsaved changes.  Are you sure you want to exit?</span>
            </div>

            <div class="modal-footer">
                <div class="row text-center">
                    <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                    <button (click)="closeModal()" type="button" class="btn btn-primary">Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*Add Relationships MODAL*/-->
<div id="ratersModalAddRelationshipsModal" class="modal fade" tabindex="-1" role="dialog" style="overflow: auto;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Relationships</h2>
                <button type="button" class="close" (click)="hideRelationshipsModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div *ngIf="!loading; else load;">

                    <div *ngIf="currentSelectedRelationshipsTab == 1" class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <p></p>
                        <div class="btns-container">
                            <a (click)="openModal('New', 0, '' )"
                               class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                               [ngClass]="{'btn-primary': !isStandard, 'btn-gray': isStandard}">
                                <i class="fas fa-plus text-white-50"> <span class="button-text">Create Relationship</span></i>
                            </a>
                        </div>
                    </div>

                    <div class="container-fluid rt-add-rater-types-modal">
                        <ul class="tab-nav">
                            <li (click)="loadData(2)" class="active in"><a data-toggle="tab" href="#assignedStandartTab1">Standard Relationships</a></li><!--standart rater types-->
                            <li (click)="loadData(1)"><a data-toggle="tab" href="#assignedCustomTab2">Custom Relationships</a></li><!--my rater types-->
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="assignedStandartTab1" class="tab-pane fade in active">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [floatingFilter]="true"
                                                 [gridOptions]="rtgridOptions"
                                                 [rowData]="raterTypesStandartData"
                                                 [columnDefs]="raterTypesStandartDataHeaders"
                                                 (rowClicked)="onRaterTypesRowClicked($event)"
                                                 (gridReady)="onRaterTypesStandartGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [rowSelection]="'multiple'"
                                                 (selectionChanged)="onRaterSelectionChanged($event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                        <div id="assignedCustomTab2" class="tab-pane fade">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [floatingFilter]="true"
                                                 [gridOptions]="rtgridOptions"
                                                 [rowData]="raterTypesCustomData"
                                                 [columnDefs]="raterTypesCustomDataHeaders"
                                                 (rowClicked)="onRaterTypesRowClicked($event)"
                                                 (gridReady)="onRaterTypesCustomGridReady($event)"
                                                 [pagination]="true"
                                                 [paginationPageSize]="25"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                 [rowSelection]="'multiple'"
                                                 (selectionChanged)="onRaterSelectionChanged($event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-template #load>
                    <div class="text-center">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                        <p>Loading, please wait...</p>
                    </div>
                </ng-template>

                <div class="modal-footer">
                    <div class="row">
                        <div class="col-md-12" style="text-align:right;">
                            <button (click)="hideRelationshipsModal()" data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                            <button (click)="addRelationships()" type="button" class="btn btn-primary">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--NEW-EDIT RATER MODAL-->
<div id="ertcreateModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">{{action}} Relationship</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" style="margin-bottom: 10px; margin-top: -5px;">
                    <div class="align-items-center justify-content-between d-sm-flex align-items-center justify-content-between mb-4">
                        <div></div>
                        <div>
                            <a *ngIf="action == 'Edit'" (click)="openConfirmationModal()" style="margin-left: 25px;" class="d-none d-sm-inline-block btn btn-sm btn-red shadow-sm margin-right-5">
                                <i class="fas fa-trash text-white-50"> <span class="button-text">Delete</span></i>
                            </a>
                            <a (click)="saveRaterType()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm   ">
                                <i class="fas fa-save text-white-50"> <span class="button-text">Save</span></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-2">
                        <label>Name:</label>
                    </div>
                    <div class="col-xs-12 col-md-10" style="padding: 0;">
                        <input #ratertName
                               id="raterName"
                               (keypress)="preventSpace(ratertName.value, $event, 'raterName')"
                               [(ngModel)]="rname"
                               placeholder="Name"
                               type="text"
                               name="name"
                               value="" />
                    </div>
                </div>
                <p id="linkToCopy" style="display:none;"></p>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="ecDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Relationship</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Relationship</b>?</p>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="deleteRaterType()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE RATERS MODAL*/-->
<div id="moveEntryModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Move Rater to...</h2>
                <button (click)="hideMoveEntryModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12 col-md-3 text-right">
                        <label>Category: </label>
                    </div>
                    <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                        <div>
                            <select id="mCategories">
                                <option disabled>--Select a Category--</option>
                                <option *ngFor="let category of moveActiveCategories" [value]="category.Id">{{category.Name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <ng-template #mLoading>
                    <div class="text-center">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                        <p>Loading, please wait...</p>
                    </div>
                </ng-template>
            </div>

            <div class="modal-footer text-right">
                <div>
                    <button (click)="hideMoveEntryModal()" data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                    <button (click)="confirmMoveEntry()" type="button" class="btn btn-primary">Ok</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div id="removeCategoryModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Remove Category</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>This will delete the uncompleted raters and will move the completed ones to a different category. Do you want to continue?</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="showNextStepRemoveCategory()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="cannotDeleteCategoryModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Remove Category</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>You can not delete this category because it is the only one available at this assignment</p>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-primary">Okay</button>
                        <!-- <button (click)="showNewCategoryDialog()" type="button" class="btn btn-primary">Yes</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="selectNewCategoryModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">New Category</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Which category would you like to move the completed clients to?</p>

                <div class="row">
                    <div class="col-12 col-md-3">
                        <label>Type: </label>
                    </div>
                    <div class="col-12 col-md-8">
                        <select #_assessmentNewCategory id="assessmentNewCategory">
                            <option *ngFor="let type of assignmentNewCategories" [value]="type.Id">{{type.Name}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="setNewCategory(_assessmentNewCategory.value)" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--raters types-->
<app-rater-types-for-modal #raterTypesForModal></app-rater-types-for-modal>


